import {IntermediatePart} from "../../intermediatePart";

export default class BathTubBody extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = "bathtub_body";
    this.partName = 'Bathtub';
    this.translateId = "visualizer.bathroom.bathtub.bathtub";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new BathTubBody());
  }

  disabledClick() {
    const bathTubFixture = this.getParent().bathTubFixture;
    if (bathTubFixture) {
      bathTubFixture.disabled = this.disabled;
    }
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Bathtub.BathTubBody;
    }
  }
}
